export default __webpack_public_path__ + "static/media/tour-3.96b104c2.svg";